<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-community @community-change="handleCommunityChange"></admin-community>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="clearfix flex justify-between">
            <div>{{ $t('communityRecommend.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="communityRecommendInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-select v-model="communityRecommendInfo.conditions.recommendType" style="width:100%"
                  :placeholder="$t('communityRecommend.selectRecommendType')">
                  <el-option v-for="item in recommendTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryCommunityRecommendMethod">
                  {{ $t('common.query') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <div>{{ $t('communityRecommend.communityRecommend') }}</div>
            <div v-if="communityRecommendInfo.conditions.communityId" style="float: right;">
              <el-button type="primary" size="small" @click="_openAddShopRecommend">
                {{ $t('communityRecommend.linkGoods') }}
              </el-button>
              <el-button type="primary" size="small" @click="_openAddServRecommend">
                {{ $t('communityRecommend.linkService') }}
              </el-button>
              <el-button type="primary" size="small" @click="_openAddCommunityRecommendModal">
                {{ $t('communityRecommend.linkExternal') }}
              </el-button>
            </div>
          </div>
          <div class="card-body">
            <el-table :data="communityRecommendInfo.recommends" style="width: 100%">
              <el-table-column prop="logo" :label="$t('communityRecommend.logo')" width="100" align="center">
                <template slot-scope="scope">
                  <img :src="scope.row.logo" style="width: 60px; height: 60px; border-radius: 5px;" />
                </template>
              </el-table-column>
              <el-table-column prop="communityName" :label="$t('communityRecommend.communityName')" align="center">
              </el-table-column>
              <el-table-column prop="shopName" :label="$t('communityRecommend.shopName')" align="center">
              </el-table-column>
              <el-table-column prop="recommendTypeName" :label="$t('communityRecommend.recommendType')" align="center">
              </el-table-column>
              <el-table-column prop="prodName" :label="$t('communityRecommend.name')" align="center">
              </el-table-column>
              <el-table-column prop="price" :label="$t('communityRecommend.price')" align="center">
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('communityRecommend.createTime')" align="center">
              </el-table-column>
              <el-table-column :label="$t('common.operation')" align="center" width="180">
                <template slot-scope="scope">
                  <el-button size="mini" @click="_openEditCommunityRecommendModel(scope.row)">
                    {{ $t('common.edit') }}
                  </el-button>
                  <el-button size="mini" type="danger" @click="_openDeleteCommunityRecommendModel(scope.row)">
                    {{ $t('common.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @current-change="handleCurrentChange" :current-page="communityRecommendInfo.conditions.page"
              :page-size="communityRecommendInfo.conditions.row" layout="total, prev, pager, next"
              :total="communityRecommendInfo.total">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-community-recommend ref="addCommunityRecommend" @refresh="_queryCommunityRecommendMethod"></add-community-recommend>
    <edit-community-recommend ref="editCommunityRecommend" @refresh="_queryCommunityRecommendMethod"></edit-community-recommend>
    <delete-community-recommend ref="deleteCommunityRecommend" @refresh="_queryCommunityRecommendMethod"></delete-community-recommend>
    <add-shop-recommend ref="addShopRecommend" @refresh="_queryCommunityRecommendMethod"></add-shop-recommend>
    <add-serv-recommend ref="addServRecommend" @refresh="_queryCommunityRecommendMethod"></add-serv-recommend>
  </div>
</template>

<script>
import { getCommunityRecommendList } from '@/api/phone/communityRecommend/communityRecommendApi'
import { getShopId } from '@/api/shop/shopApi'
import AdminCommunity from '@/components/shop/adminCommunity/adminCommunity'
import AddCommunityRecommend from '@/components/phone/addCommunityRecommend/addCommunityRecommend'
import EditCommunityRecommend from '@/components/phone/editCommunityRecommend/editCommunityRecommend'
import DeleteCommunityRecommend from '@/components/phone/deleteCommunityRecommend/deleteCommunityRecommend'
import AddShopRecommend from '@/components/phone/addShopRecommend/addShopRecommend'
import AddServRecommend from '@/components/phone/addServRecommend/addServRecommend'

export default {
  name: 'CommunityRecommend',
  components: {
    AdminCommunity,
    AddCommunityRecommend,
    EditCommunityRecommend,
    DeleteCommunityRecommend,
    AddShopRecommend,
    AddServRecommend
  },
  data() {
    return {
      communityRecommendInfo: {
        recommends: [],
        total: 0,
        records: 1,
        moreCondition: false,
        crId: '',
        communityName: '',
        conditions: {
          communityId: '',
          recommendType: '',
          prodName: '',
          page: 1,
          row: 10
        }
      },
      recommendTypeOptions: [
        { value: '', label: this.$t('communityRecommend.selectRecommendType') },
        { value: 'GOODS', label: this.$t('communityRecommend.goods') },
        { value: 'SERV', label: this.$t('communityRecommend.housekeepingService') },
        { value: 'OUT', label: this.$t('communityRecommend.external') }
      ]
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
    this._listCommunityRecommends(1, 10)
  },
  methods: {
    handleCommunityChange(community) {
      this.communityRecommendInfo.conditions.communityId = community.communityId
      this.communityRecommendInfo.communityName = community.name
      this._listCommunityRecommends(1, 10)
    },
    async _listCommunityRecommends(page, rows) {
      this.communityRecommendInfo.conditions.page = page
      this.communityRecommendInfo.conditions.row = rows
      try {
        const res = await getCommunityRecommendList(this.communityRecommendInfo.conditions)
        this.communityRecommendInfo.total = res.total
        this.communityRecommendInfo.records = res.records
        this.communityRecommendInfo.recommends = res.data
      } catch (error) {
        console.error('获取推荐列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listCommunityRecommends(val, this.communityRecommendInfo.conditions.row)
    },
    _openAddShopRecommend() {
      this.$refs.addShopRecommend.open({
        communityId: this.communityRecommendInfo.conditions.communityId,
        communityName: this.communityRecommendInfo.communityName
      })
    },
    _openAddServRecommend() {
      this.$refs.addServRecommend.open({
        communityId: this.communityRecommendInfo.conditions.communityId,
        communityName: this.communityRecommendInfo.communityName
      })
    },
    _openAddCommunityRecommendModal() {
      this.$refs.addCommunityRecommend.open({
        communityId: this.communityRecommendInfo.conditions.communityId,
        communityName: this.communityRecommendInfo.communityName
      })
    },
    _openEditCommunityRecommendModel(row) {
      this.$refs.editCommunityRecommend.open(row)
    },
    _openDeleteCommunityRecommendModel(row) {
      this.$refs.deleteCommunityRecommend.open(row)
    },
    _queryCommunityRecommendMethod() {
      this._listCommunityRecommends(1, 10)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>